import { ObjectSchema, boolean, number, object, string } from "yup";

import { UserDetailsFormData } from "@/pages/backoffice/backOfficeUserPage/UserDetails";

export const createUserRequestSchema: ObjectSchema<UserDetailsFormData> = object().shape({
  display_name: string().optional(),
  email_address: string().optional(),
  institution_id: number().optional(),
  canViewInstitutionValuations: boolean().optional(),
  isInstitutionAdmin: boolean().optional(),
});
